import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function PortalLayout({ children, hideLogout = false, hideNav = false }) {
  const navigate = useNavigate();
  const clientName = localStorage.getItem('portal_client_name') || '';

  const logout = () => {
    localStorage.removeItem('portal_token');
    localStorage.removeItem('portal_client_name');
    localStorage.removeItem('portal_client_email');
    localStorage.removeItem('portal_client_id');
    navigate('/portal/login');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-teal-50/40">
      {!hideNav && (
        <nav
          className="bg-white/80 backdrop-blur border-b border-gray-200 sticky z-30"
          style={{ top: 'var(--announcement-banner-height, 0px)' }}
        >
          <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <Link to="/portal/dashboard" data-testid="portal-home-link" className="flex items-center gap-3">
                <div className="relative">
                  <img
                    src="https://images.squarespace-cdn.com/content/v1/6329980709c417765c18ef9c/1663928993488-9PHELX1GHR1MGT4SNOLP/minchio+brothers+logo.png?format=100w"
                    alt="Minchio Brothers"
                    className="h-10 w-10 rounded-lg"
                  />
                  <span className="absolute -bottom-1 -right-1 w-3 h-3 bg-teal-500 border-2 border-white rounded-full"></span>
                </div>
                <div>
                  <div className="text-[11px] font-semibold uppercase tracking-widest text-teal-600 leading-none">Minchio Brothers</div>
                  <h1 className="text-lg font-bold text-gray-900 leading-tight">Client Portal</h1>
                </div>
              </Link>
              <div className="flex items-center gap-4">
                {clientName && (
                  <div className="hidden sm:flex items-center gap-2 bg-teal-50 border border-teal-100 px-3 py-1.5 rounded-full">
                    <span className="h-6 w-6 bg-teal-600 text-white text-xs font-bold rounded-full flex items-center justify-center">
                      {clientName.trim().charAt(0).toUpperCase() || 'C'}
                    </span>
                    <span className="text-sm text-teal-800 font-medium">{clientName}</span>
                  </div>
                )}
                {!hideLogout && (
                  <button onClick={logout} data-testid="portal-logout-btn" className="text-sm text-gray-500 hover:text-red-600 font-medium">
                    <i className="ri-logout-box-line"></i> Sign out
                  </button>
                )}
              </div>
            </div>
          </div>
        </nav>
      )}
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">{children}</main>
      <footer className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-center text-xs text-gray-400">
        © Minchio Brothers Productions · Townsville, QLD · <a className="text-teal-600 hover:text-teal-700" href="tel:+61431323137">+61 431 323 137</a>
      </footer>
    </div>
  );
}
